@if (endtType === "EC175") {
  @for (item of narrationHTML; track $index) {
    <div *ngIf="isUserInput(item)">
      <form [formGroup]="narrationForm">
        <div class="input_container customField formfield_no_padding">
          <nx-formfield>
            <textarea nxInput cdkTextareaAutosize (keyup)="onKeyUp($event)" formControlName="txtNarration" appToUpperCase maxLength="200">
            </textarea>
          </nx-formfield>
        </div>
        <div class="container_flex_center align_right">
            <span nxCopytext="small" class="nx-margin-top-2xs">
                <span *ngIf="characterCount === 0">
                    {{ 'COMMON.CHAR_MAX_LIMIT' | translate: { fieldName: 200 } }}
                  </span>
                  <span *ngIf="characterCount > 0">
                    {{ 200 - txtNarration.value.length }} {{ 'COMMON.CHAR_REMAINING' | translate }}
                  </span>
            </span>
          </div>
      </form>
    </div>
    <div [innerHTML]="sanitizier.bypassSecurityTrustHtml('&lt;p&gt;' + item.innerHTML + '&lt;/p&gt;')" *ngIf="!isUserInput(item)"></div>
  }
} @else {
  <div [innerHTML]="safeEndtNarration" class="narration-content"></div>
}
